// The placeholder shown wherever a value is missing (detail tables, list cells).
//
// It lives in its own leaf module - with no imports at all - so that pure helpers can reach
// it without pulling in competitorDetailRows' `ReportBuilderMixin` import, which drags the
// whole builder component graph into anything that touches it (unit tests included).
// competitorDetailRows re-exports it, so existing importers are unaffected.
export const EMPTY = "—";
